// extracted by mini-css-extract-plugin
export default {"container":"PlayButton_container__QL18J","button":"PlayButton_button__g-Q0c","polygon":"PlayButton_polygon__4uriw"};